(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  function norm(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function first(selectors, root) {
    var scope = root || document;
    for (var i = 0; i < selectors.length; i++) {
      var found = scope.querySelector(selectors[i]);
      if (found) return found;
    }
    return null;
  }

  function replaceAddToCartText(root) {
    if (!root) return;
    var buttons = root.querySelectorAll('.t4s-product-form__submit, button[name="add"], [type="submit"][name="add"]');
    buttons.forEach(function (button) {
      if (/sold out|unavailable/i.test(norm(button.textContent))) return;
      var walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (/add to cart/i.test(node.nodeValue || '')) {
          node.nodeValue = node.nodeValue.replace(/add to cart/ig, 'ADD TO BAG');
        }
      }
    });
  }

  function hideLegacyPolicyAccordions() {
    var titles = document.querySelectorAll('.t4s-accordion-title, [data-t4s-tab-item]');
    titles.forEach(function (title) {
      var text = norm(title.textContent).toLowerCase();
      var isDelivery = /^(delivery|delivery information|shipping|shipping information)$/.test(text);
      var isReturns = /^(returns|returns & refunds|returns and refunds|refunds|shipping & returns|shipping and returns)$/.test(text);
      if (!isDelivery && !isReturns) return;
      var row = title.closest('.t4s-pr-accordion, .t4s-tab-wrapper, .t4s-product__accordion');
      if (row) row.classList.add('osl-pdp-legacy-policy');
    });
  }

  function hideLegacyCountdown(productRoot) {
    var nodes = productRoot ? productRoot.querySelectorAll('div, p, span') : [];
    var candidates = [];
    nodes.forEach(function (el) {
      var text = norm(el.textContent).toLowerCase();
      if (text.indexOf('hurry up! sale end in') !== -1 || text.indexOf('hurry up! sale ends in') !== -1) {
        if (text.length < 550) candidates.push(el);
      }
    });
    if (!candidates.length) return;
    candidates.sort(function (a, b) { return norm(a.textContent).length - norm(b.textContent).length; });
    var target = candidates[0].closest('[class*="countdown"], [class*="timer"], .t4s-product__info-item, div') || candidates[0];
    if (target) target.classList.add('osl-pdp-legacy-countdown');
  }

  function findLegacyTrust() {
    var terms = ['real person support', 'satisfied or refunded', 'trusted retailer', '100% secure payments'];
    var candidates = [];
    document.querySelectorAll('section, div').forEach(function (el) {
      if (el.id === 'OSLProductEnhancements' || el.closest('#OSLProductEnhancements')) return;
      var text = norm(el.textContent).toLowerCase();
      if (!text || text.length > 2200) return;
      var hits = 0;
      terms.forEach(function (term) { if (text.indexOf(term) !== -1) hits++; });
      if (hits >= 3) candidates.push(el);
    });
    if (!candidates.length) return null;
    candidates.sort(function (a, b) { return norm(a.textContent).length - norm(b.textContent).length; });
    return candidates[0];
  }

  function markRecommendationHeadings() {
    document.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(function (heading) {
      var text = norm(heading.textContent);
      if (/^(recommended products|you may also like)$/i.test(text)) {
        heading.textContent = 'You May Also Love';
        heading.classList.add('osl-pdp-section-heading');
      } else if (/^recently viewed$/i.test(text)) {
        heading.classList.add('osl-pdp-section-heading');
      }
    });
  }

  function init() {
    if (document.body.classList.contains('osl-pdp-ready')) return;

    var source = document.getElementById('OSLProductEnhancements');
    var productRoot = first(['.t4s-product', '[data-product-featured]', '.product']);
    var info = first(['.t4s-product__info-container', '[id^="ProductInfo-"]', '.wrap-product-info'], productRoot || document);
    if (!source || !productRoot || !info) return;

    document.body.classList.add('osl-pdp-ready');

    var title = first(['.t4s-product__title', '.pr_title', 'h1'], info);
    var price = first(['.t4s-product__price-review', '.priceSingle', '.product__price'], info);
    var description = first(['.t4s-product__description', '.pr_desc', '[class*="product__description"]'], info);

    /* Supplier/vendor bylines are intentionally removed from the storefront. */
    info.querySelectorAll('.t4s-product__vendor, .product_meta .vendor, .vendorLink, [class*="product__vendor"]').forEach(function (label) { label.remove(); });

    /* Compact factual reassurance under the price. */
    var microtrust = source.querySelector('[data-osl-role="microtrust"]');
    if (microtrust) {
      if (price && price.parentNode) price.insertAdjacentElement('afterend', microtrust);
      else if (title) title.insertAdjacentElement('afterend', microtrust);
      else info.insertBefore(microtrust, info.firstChild);
    }

    /* Fit Notes only exist when verified/custom OSL fit metafields exist. */
    var fitNotes = source.querySelector('.osl-fit-notes');
    var details = source.querySelector('[data-osl-role="details"]');
    var anchor = description || price || title;
    if (fitNotes && anchor) {
      anchor.insertAdjacentElement('afterend', fitNotes);
      anchor = fitNotes;
    }
    if (details && anchor) {
      anchor.insertAdjacentElement('afterend', details);
    } else if (details) {
      info.appendChild(details);
    }

    hideLegacyPolicyAccordions();
    hideLegacyCountdown(productRoot);

    /* Replace the old emoji/unsupported-review reassurance strip if it is present. */
    var reassurance = source.querySelector('[data-osl-role="reassurance"]');
    var legacyTrust = findLegacyTrust();
    if (legacyTrust) {
      legacyTrust.classList.add('osl-pdp-legacy-trust');
      if (reassurance) legacyTrust.insertAdjacentElement('beforebegin', reassurance);
    } else if (reassurance) {
      var productSection = productRoot.closest('.shopify-section') || productRoot;
      productSection.insertAdjacentElement('afterend', reassurance);
    }

    replaceAddToCartText(info);
    markRecommendationHeadings();

    /* Theme scripts can rewrite button labels after variant changes. Keep only the wording in sync. */
    var observer = new MutationObserver(function () {
      replaceAddToCartText(info);
      markRecommendationHeadings();
    });
    observer.observe(info, { childList: true, subtree: true, characterData: true });

    source.remove();
  }

  ready(init);
})();